// Pre login
export enum EPreAuthRoutes {
  HOME = '/',
  REGISTRATION = '/registration',
  LOGIN_ERROR = '/login-error',
  LOGIN_LOADING = '/login-loading',
  LOGIN_SYNC_WAIT = '/login-sync-wait',
}
